import { RootState } from '@/Redux/RootReducer';
import { createSelector } from '@reduxjs/toolkit';
import { countryZoneUtils } from './utils';

const generatorCountryZoneState = (state: RootState) => state.warehouseLogisticsPage.countryZones;

const selectedCountryCode = createSelector(generatorCountryZoneState, (state) => state.selectedCountryCode);

const selectedCountryZone = createSelector(generatorCountryZoneState, (state) =>
  state.countryZones.find((x) => x.country === state.selectedCountryCode),
);

const countryZoneById = (countryZoneId: string | number) => {
  return createSelector(generatorCountryZoneState, (state) => {
    return countryZoneUtils.countryZoneById(countryZoneId, state.countryZones);
  });
};

export const generatorCountryZoneSelectors = {
  countryZoneById,
  selectedCountryCode,
  selectedCountryZone,
};
